<template>
  <div class="toolbar">
    <nav class="toolbar--nav" role="navigation" aria-label="Tool bar">
      <ol class="toolbar--list">
        <li v-for="menu in toolbar" @click="openDropdown(menu)" class="toolbar--list__item"
            :key="menu.toolbar"
            :class="[ menu.hasDropdown ? 'hasSubmenu' : '', menu.isOpen ? 'openDropdown' : '' ]">
            <p4a-icon class="toolbar--list__item--icon"
                      :icon="menu.icon" />
            {{ menu.name }}
          <div v-if="menu.hasDropdown">
            <ol class="toolbar--list__sub"
                v-show="menu.children && menu.children.length">
              <li v-show="menu.hasDropdown"
                  v-for="lvl1 in menu.children"
                  :key="lvl1.toolbar"
                  @click="openDropdown(lvl1)"
                  :class="[ lvl1.hasDropdown ? 'hasSubmenu' : '', lvl1.isOpen ? 'openDropdown' : '' ]">
                  <p4a-icon class="toolbar--list__item--icon"
                            :icon="lvl1.icon" />
                    {{ lvl1.name }}
                <div v-if="lvl1.hasDropdown">
                  <ol class="toolbar--list__sub--sub" v-show="lvl1.children && lvl1.children.length">
                    <li v-show="lvl1.hasDropdown"
                        v-for="lvl2 in lvl1.children"
                        :key="lvl2.toolbar">
                        <p4a-icon class="toolbar--list__item--icon"
                                  :icon="lvl2.icon" />
                          {{ lvl2.name }}
                    </li>
                  </ol>
                </div>
              </li>
            </ol>
          </div>
        </li>
      </ol>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'toolbar',
  props: {
    menu: Object
  },
  data () {
    return {
      toolbar: [
        {
          id: 1,
          name: this.$t('toolbar.new'),
          icon: 'expand',
          hasDropdown: true,
          isOpen: false,
          children: [
            {
              id: 11,
              name: this.$t('toolbar.import'),
              icon: 'accepted',
              hasDropdown: true,
              isOpen: false,
              children: [
                {
                  id: 111,
                  icon: 'accepted',
                  name: 'Sub menu 1'
                }
              ]
            },
            {
              id: 1.2,
              name: this.$t('toolbar.newViaTemplate'),
              icon: 'accepted',
              hasDropdown: true,
              isOpen: false,
              children: [
                {
                  id: 112,
                  name: 'Sub menu 2'
                }
              ]
            },
            {
              id: 1.3,
              name: this.$t('toolbar.expected'),
              icon: 'accepted'
            },
            {
              id: 1.4,
              name: this.$t('toolbar.newFolder'),
              icon: 'accepted'
            },
            {
              id: 1.5,
              name: this.$t('toolbar.newFolderViaTemplate'),
              icon: 'accepted'
            }
          ]
        },
        {
          id: 2,
          name: this.$t('toolbar.show'),
          icon: 'show-all'
        },
        {
          id: 3,
          name: this.$t('toolbar.edit'),
          icon: 'change'
        },
        {
          id: 4,
          name: this.$t('toolbar.publish'),
          icon: 'upload'
        },
        {
          id: 5,
          name: this.$t('toolbar.search'),
          icon: 'open-file'
        },
        {
          id: 6,
          name: this.$t('toolbar.status'),
          icon: 'status'
        },
        {
          id: 7,
          name: this.$t('toolbar.stamp'),
          icon: 'stamp'
        },
        {
          id: 8,
          name: this.$t('toolbar.QRCode'),
          icon: 'qr'
        },
        {
          id: 9,
          name: this.$t('toolbar.message'),
          icon: 'mail'
        },
        {
          id: 10,
          name: this.$t('toolbar.printOrder'),
          icon: 'print'
        },
        {
          id: 11,
          name: this.$t('toolbar.version'),
          icon: 'time'
        },
        {
          id: 12,
          name: this.$t('toolbar.view'),
          icon: 'ifcspace',
          hasDropdown: true,
          isOpen: false,
          children: [
            {
              id: 121,
              name: 'Sub menu'
            }
          ]
        },
        {
          id: 13,
          name: this.$t('toolbar.extra'),
          icon: 'properties',
          hasDropdown: true,
          isOpen: false,
          children: [
            {
              id: 121,
              name: 'Sub menu',
              hasDropdown: true,
              isOpen: false,
              children: [
                {
                  id: 112,
                  name: 'Sub menu 2'
                }
              ]
            }
          ]
        }
      ]
    }
  },
  methods: {
    openDropdown (toolbar) {
      if (toolbar.hasDropdown) {
        toolbar.isOpen = !toolbar.isOpen
      }
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/toolBar/toolBar.vue